<template lang="html">
  <div class="print-save ph">
    <a @click.stop="printDialog" class="grey link">
      PRINT
    </a>
  </div>
</template>

<script>
export default {
  methods: {
    printDialog() {
      if (window.print) {
        window.print();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.print-save {
  width: 100%;
  text-align: right;
  padding-bottom: calc(1.5 * var(--lh));
  @media only print {
    display: none;
  }
  &.abs {
    position: absolute;
    top: 0;
    right: 0;
    width: auto;
    z-index: 999;
  }
}
</style>
